import useSWRMutation from 'swr/mutation';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {ServerStatus} from './types';

export function fetchServerStatusRequest() {
  return useSWRMutation<ServerStatus, Error, string, null>(
    '/api/v1/status/',
    async (url) => {
      const response = await letrusAPI(url, {method: 'get'});
      return response.data;
    },
    {throwOnError: false},
  );
}
